import { IPricingDocumentItemDTO } from "../../libs/coreapi-dto/dirs/pricingInvoice";
import CoreApiService from "../../system/api/coreApiService";


export class PricingDisaggregationDataProvider {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        this._coreApiService = coreApiService
    }

    calculateItem(idGoods: string, body: IPricingDocumentItemDTO, callback?: (data: IPricingDocumentItemDTO) => void) {
        this._coreApiService.pricingDisaggregationRequest
            .then(r =>
                r.sendCalculateItemRequest(idGoods, body, (e) => {
                    if (e.respType === 'isCompleted')
                        callback?.(e.data);
                    else
                        throw new Error(e.message.title);
                })
            );
    }
}